<template>
  <ModalDialog
    ref="dialog"
    :title="title"
    icon="fa-pause"
    sizeClass='modal-med'
    :submitting="submitting"
    :submitTitle="submitTitle"
    @closed="onClosed"
    @submitted="onSubmitted">

    <FormGroup v-bind:form="textEntryForm" :labelColumnSize="3">
      <FormUploadDropTarget @filesDropped="$refs.documentUpload.filesDroppedFromTarget($event)">
        <NotificationBar type="warning" v-if="warningText">
          <NotificationBarTitle>Note</NotificationBarTitle>
          {{warningText}}
        </NotificationBar>
        <FormRow label="Hold Type">
          <FormSelect :options="holdTypeOptions" v-model="holdType" field="holdType" />          
        </FormRow>
        <FormRow label="Hold Reason">
          <FormInputTextArea ref="textEntryArea" v-model="text" placeholder="Enter the reason for the hold" field="reason" />
        </FormRow>
        <FormRow label="Attachments">
          <FormUpload ref="documentUpload" v-model="uploadFileList" field="uploadFileList" />
        </FormRow>
      </FormUploadDropTarget>
    </FormGroup>
  </ModalDialog>
</template>

<script>
import _ from 'lodash'
import form from '@/mixins/form'
import ModalDialog from '@/components/modalDialog.vue'
import modalDialog from '@/mixins/modalDialog'

import { OrderHoldTypes, OrderHoldTypeLookup } from '@/store/types'

export default {
  name: "OrderActionDialog",
  mixins: [
    modalDialog,
    form
  ],
  components: {
    ModalDialog
  },
  props: {
    title: String,
    submitTitle: String,
    submitPromise: Function
  },
  data() {
    return {
      submitting: false,
      text: '',
      holdType: null,   // No default. Need to select one
      uploadFileList: [],
      textEntryForm: {},
      holdTypeOptions: _.concat([{ name: 'Select Hold Type', value: null }], OrderHoldTypeLookup)
    }
  },
  created() {
  },
  mounted() {
    this.$nextTick(() => {
      this.$refs.textEntryArea.focus()
    })
  },
  computed: {
    warningText() {
      if(this.holdType == OrderHoldTypes.accounts)
        return 'Accounts hold will require a user with Accounts Approval permission to unhold the order'
      if(this.holdType == OrderHoldTypes.stock || this.holdType == OrderHoldTypes.production)
        return 'Stock / Production hold will require a user with Production Approval permission to unhold the order'

      return ''      
    }
  },
  methods: {
    show(params) {
      this.textEntryForm = {}
      return modalDialog.methods.show.call(this, params)
    },
    onClosed() {
      this.modalClosed(false)
    },
    onSubmitted() {
      if(!this.$refs.documentUpload.validateUploadsComplete())
        return
        
      this.submitting = true
      this.textEntryForm = {}

      this.submitPromise({ holdType: this.holdType, text: this.text, uploadFileList: this.uploadFileList })
        .then(() => {
          this.submitting = false
          this.modalClosed(true)
          this.hide()
        })
        .catch(err => {
          this.submitting = false
          this.$data.textEntryForm = this.processFormResponse(err)
        })
        .finally(() => {
          this.submitting = false
        })
    }
  }
}
</script>